export default "__VITE_ASSET__df16b41f__"